export * from './item-small-generic';
export * from './list-filter';
export * from './list-items'

import { ItemSmallGenericComponent } from './item-small-generic';
import { ListFilterComponent } from './list-filter';
import { ListItemsComponent } from './list-items';

export const ListAtoms = [
    ItemSmallGenericComponent,
    ListFilterComponent,
    ListItemsComponent
];